import React, { Component } from 'react';
import './TopDashboard.css';
import firebase from '../firebase';

// Presence check

class TopDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: this.props.username,
    };
  }

  componentDidMount() {
    this.checkPresence();
  }

  componentWillUnmount() {
    firebase
      .database()
      .ref(`/UsersOnline/${this.props.username}`)
      .remove();
  }

  checkPresence = () => {
    const onlineRef = firebase.database().ref(`/UsersOnline`);
    const userRef = firebase
      .database()
      .ref(`/UsersOnline/${this.props.username}`);
    const presenceRef = firebase.database().ref(`.info/connected`);
    presenceRef.on('value', snapshot => {
      if (snapshot.val()) {
        userRef.onDisconnect().remove();
        userRef.set(true);
      }
    });
    onlineRef.on('value', snapshot => {
      this.setState({
        usersOnline: snapshot.numChildren(),
      });
    });
  };

  render() {
    const { username, usersOnline } = this.state;
    const { mobileRooms } = this.props;
    return (
      <div className="dashboard">
        <button
          className="mobile-rooms-toggle"
          type="submit"
          onClick={this.props.toggleMobileRooms}
        >
          {mobileRooms ? 'Back' : 'Rooms'}
        </button>
        <div className="dashboard-username">
          <p className="dashboard-welcome">
            <span>Welcome,</span> {username}!
          </p>
          <button
            className="dashboard-changename"
            type="submit"
            onClick={this.props.changeName}
          >
            Change name
          </button>
        </div>
        <p>
          <span className="dashboard-online">Online:</span>{' '}
          <span className="dashboard-circle">●</span>
          {usersOnline}
        </p>
        {/* <div className="current-mobile-room">
          <p>Current room: {currentRoom}</p>
        </div> */}
      </div>
    );
  }
}

export default TopDashboard;
